import { SUPPORTED_SELLER_LANGUAGES_MAP } from './constants';

export const SUPPORTED_SELLER_LANGUAGES = Object.keys(SUPPORTED_SELLER_LANGUAGES_MAP);

/**
 * Check if we support the language as a possible proficient language of the seller.
 * @param languageCode {string} - might be locale ('en-US') or language code ('en'), check for existence as-is
 * @returns {boolean} - the language supported or not
 */
export const isSupportedSellerLanguage = (languageCode) => !!SUPPORTED_SELLER_LANGUAGES_MAP[languageCode];

/**
 * Returns the native name of the language.
 * @param locale {string} - check for existence as-is, no trimming, etc.
 * @returns {string} - the native name of the language
 */
export const getSellerLanguageNativeName = (languageCode) => SUPPORTED_SELLER_LANGUAGES_MAP[languageCode] || languageCode;
